import { useMsal } from '@azure/msal-react';

export const useSSoUserMeta = () => {
  const { accounts } = useMsal();
  return {
    name: accounts?.[0]?.name,
  };
};
